<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
<div class="container-fluid">
    <!-- Header -->
    <div class="header">
        <span class="welcome">Xin chào: <b>{{ user }}</b></span>
        <a class="logout" @click="logoutTaiKhoan">Đăng xuất</a>
    </div>

    <!-- Tabs -->
    <div class="tabs">
        <button :class="{ active: activeTab === 1 }" @click="clickDanhMuc">
            QUẢN TRỊ DANH MỤC
        </button>
        <button :class="{ active: activeTab === 2 }" @click="clickBaiViet">
            QUẢN TRỊ BÀI VIẾT
        </button>
        <button @click="clickUploadImg">ĐẨY ẢNH LÊN SERVER</button>
        <button :class="{ active: activeTab === 3 }" @click="clickNhanSu">
            QUẢN TRỊ NHÂN SỰ
        </button>
    </div>
    <div v-if="showUploadImgPopup" class="popup-overlay">
        <div class="popup-content" style="width: -WEBKIT-FILL-AVAILABLE">
            <div class="w-100 d-flex justify-content-end">
                <button style="
              align-items: end;
              background: none;
              width: 30px;
              height: 30px;
              border-radius: 50%;
              color: red;
              border: 3px solid;
            " @click="showUploadImgPopup = false">
                    X
                </button>
            </div>
            <DayAnhLenServerPup> </DayAnhLenServerPup>
        </div>
    </div>
    <!-- Main -->
    <div class="container-fluid">
        <div class="row justify-content-around">
            <!-- Form -->
            <div class="card-cate list-section-cate col-12 col-md-8 p-2">
                <div class="header-group">
                    <h5>{{ tenNhom }}</h5>

                    <span> Tổng : {{ formatTien(tongGiaoDich) }} giao dịch</span>
                    <span> Tổng tiền : {{ formatTien(tongTien) }} đ</span>
                    <span> Tổng phí : {{ formatTien(tongPhi) }} đ</span>
                    <span> Tổng : {{ diemThanhToan }} điểm kinh doanh</span>
                    <strong style="color: blue; cursor: pointer;" @click="xemSaoKe" v-if="cuaHang"> Xem sao kê >>></strong>
                    <strong style="color: blue; cursor: pointer;" @click="xemSaoKe" v-if="saoKeNhom"> Xem cửa hàng >>></strong>

                    <!-- <button class="btn-add">
              Thông tin Nhân viên/ Cửa hàng
            </button>

            <button class="btn-add" @click="showThemNvPopup = true">
              <i class="fas fa-user-plus"></i> Sao kê Giao dịch
            </button> -->
                </div>
                <div class="container-fluid mt-2" v-if="cuaHang">
                    <div class="row justify-content-start gap-3">
                        <div v-if="listNVKinhDoanh.length > 0" class="info-card" v-for="itemNV in sortedNV" :key="itemNV.id" @click="selectedNV = itemNV && getDanhSachCuaHangTrongNhom(itemNV.id)" :class="{ active: selectedNV && selectedNV.id === itemNV.id }">
                            <div class="d-flex w-100 justify-content-between ">
                                <span class="role" :class="{
                  truong: itemNV.level == 1,
                  pho: itemNV.level == 2,
                  tv: itemNV.level == 0
                }">
                                    {{ itemNV.level == 1 ? 'Trưởng nhóm' :
                    itemNV.level == 2 ? 'Phó nhóm' :
                      'Hỗ trợ' }}
                                </span> <span class="mt-1" style="font-weight: 600; "> {{ itemNV.soDiemDaTao }} </span></div>
                            <div class="name">{{ itemNV.hoTen }} - {{ itemNV.viVimass }}</div>
                            <div class="email">{{ itemNV.email }}</div>
                        </div>

                        <div class="info-card no-data m-auto" v-else>
                            <i class="fas fa-user-slash"></i> Chưa có nhân viên nào
                        </div>

                        <!-- 👉 Nút thêm nhân viên đặt cuối -->
                        <div class="info-card add-card m-auto" @click="showThemNvPopup = true">
                            <i class="fas fa-user-plus"></i> Thêm nhân viên
                        </div>
                    </div>
                    <!-- <div v-if="selectedNV" class="info-detail">
              <div class="info-header">
                <span style="font-weight: 600; font-size: 18px;">{{ selectedNV.hoTen }}</span>
                <span class="badge-role" :class="{
                  leader: selectedNV.level == 1,
                  vice: selectedNV.level == 2,
                  support: selectedNV.level == 0
                }">
                  {{ selectedNV.level == 1 ? "Trưởng Nhóm" : selectedNV.level == 2 ? "Phó Nhóm" : "Hỗ trợ" }}
                </span>
              </div>
              <div class="d-flex">
                <div> <img v-if="avatar" :src="avatar" alt="Avatar" class="info-avatar" />
                  <img v-else
                    src="https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper-thumbnail.png"
                    alt="Avatar" class="info-avatar" />
                </div>
                <div class="d-flex flex-column">

                  <p class="info-item">
                    <strong><i class="fa fa-wallet"></i> Ví Vimass:</strong> {{ viVimass }}
                  </p>
                  <p class="info-item">
                    <strong><i class="fa fa-envelope"></i> Email:</strong> {{ selectedNV.email }}
                  </p>
                  <p class="info-item">
                    <strong><i class="fa fa-phone"></i> Số điện thoại:</strong>
                    {{ selectedNV.sdt ? selectedNV.sdt : "Chưa cập nhật" }}
                  </p>

                </div>
              </div>

            </div> -->
                </div>
                <div class="container-fluid mt-3" v-if="cuaHang">
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-bordered table-striped table-sm">
                                <thead class="table-dark">
                                    <tr>
                                        <th>STT</th>
                                        <th>Tên cửa hàng</th>
                                        <th>Địa chỉ</th>
                                        <th>Người tạo</th>
                                        <th>Thời gian cập nhật</th>
                                    </tr>
                                </thead>
                                <tbody id="storeTable">
                                    <template v-for="(data, index) in listCuaHangNVTao" :key="data.id">
                                        <!-- Dòng chính -->
                                        <tr @click="toggleRow(index)" style="cursor: pointer">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ data.storeName }}</td>
                                            <td>{{ data.storeAdd }}</td>
                                            <!-- <td>{{ getTenNhanVien(data.accOwner) }} - {{ formatDate(data.timeCreate) }}</td> -->
                                            <td>{{ getTenNhanVien(data.userEdit)  }}</td>
                                            <td>{{ formatDate(data.timeEnd) }}</td>
                                        </tr>

                                        <!-- Dòng chi tiết xổ xuống -->
                                        <tr v-if="openRow === index">
                                            <td colspan="5">
                                                <div class="detail-card-modern p-3">
                                                    <div class="detail-header">
                                                        <i class="fas fa-info-circle"></i> Thông tin chi tiết cửa hàng
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-md-6 detail-left">
                                                            <div class="detail-info"><strong>Tên cửa hàng:</strong> {{ data.storeName }}</div>
                                                            <div class="detail-info">
                                                                <strong>Địa chỉ:</strong>
                                                                <a :href="`https://www.google.com/maps/search/?api=1&query=${data.lat},${data.lng}`" target="_blank">
                                                                    {{ data.storeAdd }}
                                                                </a>
                                                            </div>
                                                            <div class="detail-info"><strong>Điện thoại:</strong> {{ data.accOwner }}</div>
                                                            <div class="detail-info"><strong>Mã nộp tiền:</strong> {{ data.maNopTien }}</div>
                                                            <div class="detail-info"><strong>Tọa độ:</strong> {{ data.lat }}, {{ data.lng }}</div>
                                                            <div class="detail-info"><strong>Thời gian chỉnh sửa:</strong> {{
                                  formatDate(data.timeEnd) }}</div>
                                                        </div>

                                                        <div class="col-md-6">
                                                            <div class="detail-map">
                                                                <iframe :src="`https://www.google.com/maps?q=${data.lat},${data.lng}&hl=vi&z=16&output=embed`" width="100%" height="100%" style="border:0" loading="lazy"></iframe>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tbody v-if="listCuaHangNVTao.length === 0">
                                    <tr>
                                        <td colspan="5" class="text-center">Chưa có cửa hàng nào</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="container-fluid mt-3 " v-if="saoKeNhom">
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-bordered table-striped table-sm">
                                <thead class="table-dark">
                                    <tr>
                                        <th>STT</th>
                                        <th>Số tiền</th>
                                        <th>Phí</th>

                                        <th>Nội dung</th>
                                        <th>Thời gian</th>
                                    </tr>
                                </thead>
                                <tbody id="storeTable">
                                    <template v-for="(item, index) in listSaoKeGiaoDich" :key="index">
                                        <tr>
                                            <td>{{ index + 1 }}</td>
                                            <td class="td--color" style="color: green;"> + {{ formatTien(item.amount) }}</td>
                                            <td>{{ formatTien(item.phi) }}</td>

                                            <td>{{ item.content }}</td>
                                            <td style="color: #777777;">{{ formatDate(item.transTime) }}</td>
                                        </tr>

                                    </template>
                                </tbody>
                                <tbody v-if="listSaoKeGiaoDich.length === 0">
                                    <tr>
                                        <td colspan="5" class="text-center">Chưa có giao dịch nào</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- List -->
            <div class="card-cate list-section col-12 col-md-3 p-4">
                <div class="search-bar d-flex align-items-center w-50">
                    <button class="btn-add" @click="showThemNhomPopup = true">
                        + Thêm nhóm
                    </button>
                </div>
                <ul>
                    <li v-for="item in listnhomkd" :key="item.id">
                        <div class="d-flex flex-column w-100">
                            <div class="w-100 d-flex justify-content-around">
                                <a href="#" class="category-link text-start" @click.prevent="getDanhSachNguoiTrongNhom(item)">
                                    {{ item.tenNhom }} - ID: {{ item.id }}
                                </a>
                                <div class="d-flex">
                                    <span class="icon edit" title="Sửa" @click="moPopupSuaNhom(item)"></span>
                                    <span class="icon delete" title="Xóa" @click="confirmDelete(item)"></span>
                                </div>
                            </div>
                            <div class="text-start mt-2 d-flex justify-content-between" style="font-size: 12px; color: #888">
                                <div class="d-flex flex-column">
                                    <span> Tg tạo : {{ formatDate(item.timeCreate) }}</span>
                                    <span> Tg cập nhật : {{ formatDate(item.timeUpdates) }}</span>
                                </div>
                                <span> Người tạo : {{ item.userCreate }} </span>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- Popup xác nhận xóa -->
                <div v-if="showDeletePopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Bạn có muốn xóa {{ tenNhomXoa }}?</h5>
                        <p>
                        </p>
                        <label>Nhập token xác nhận:</label>
                        <input type="text" v-model="deleteToken" />
                        <div class="popup-actions">
                            <button @click="deleteBaiViet">Xác nhận</button>
                            <button @click="showDeletePopup = false">Hủy</button>
                        </div>
                    </div>
                </div>

                <!-- Popup Thêm-->
                <div v-if="showThemNhomPopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Thêm nhóm</h5>
                        <label>Nhập tên nhóm:</label>
                        <input type="text  a" v-model="tenNhom" />
                        <label>Nhập token xác nhận:</label>
                        <input type="text" v-model="themNhomToken" />
                        <div class="popup-actions">
                            <button @click="themNhomKD()">Xác nhận</button>
                            <button @click="showThemNhomPopup = false">Hủy</button>
                        </div>
                    </div>
                </div>
                <!-- Popup Sửa-->
                <div v-if="showSuaNhomPopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Sửa nhóm</h5>
                        <label>Tên nhóm:</label>
                        <input type="text" v-model="tenNhom" />
                        <label>Token xác nhận:</label>
                        <input type="text" v-model="themNhomToken" />
                        <div class="popup-actions">
                            <button @click="suaNhom()">Cập nhật</button>
                            <button @click="showSuaNhomPopup = false">Hủy</button>
                        </div>
                    </div>
                </div>

                <!-- Popup Thêm nv-->
                <div v-if="showThemNVpopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Thêm Thành Viên</h5>
                        <label>Nhập tên nhân viên:</label>
                        <input type="text" v-model="tenNV" />
                        <label>Nhập token xác nhận:</label>
                        <input type="text" v-model="themNhomToken" />
                        <div class="popup-actions">
                            <button>Xác nhận</button>
                            <button @click="showThemNVpopup = false">Hủy</button>
                        </div>
                    </div>
                </div>
                <!-- Popup Sửa nv-->
                <div v-if="showSuaNVPopup" class="popup-overlay">
                    <div class="popup-content">
                        <h5>Sửa nhóm</h5>
                        <label>Tên nhóm:</label>
                        <input type="text" v-model="tenNV" />
                        <label>Token xác nhận:</label>
                        <input type="text" v-model="themNhomToken" />
                        <div class="popup-actions">
                            <button>Cập nhật</button>
                            <button @click="showSuaNhomPopup = false">Hủy</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div v-if="isLoading" class="loading-overlay">
    <div class="loading-spinner"></div>
    <div class="loading-text">Đang xử lý...</div>
</div>
</template>

<script>
import {
    KEY_PHONE_ID,
    KEY_SESSION_ID
} from "@/components/listService";
import {
    postListCuaHangNVTaoKD,
    postListGiaoDichCuaHangNVTaoKD,
    postListNhomKD,
    postListNVNhomKD,
    postSuaNhomKD,
    postTaoNhomKD,
    postXoaNhomKD,
} from "@/components/VimassCrop";
import DayAnhLenServerPup from "../Vimass/Home/DayAnhLenServerPup.vue";

export default {
    name: "QuanTriBaiViet",
    components: {
        DayAnhLenServerPup,
    },
    data() {
        return {
            activeTab: 3,

            showEnglish: false,
            ckEditor: null,
            ckEditorEn: null,
            user: "",
            listCuaHangNVTao: [],
            listSaoKeGiaoDich: [],
            diemThanhToan: 0,
            tongTien: 0,
            tongGiaoDich: 0,
            tongPhi: 0,
            catParam: [{
                idDanhMucCha: "",
                pos: 0,
            }, ],
            selectedNV: null,
            currentPage: 1,
            pageSize: 50,
            listnhomkd: [],
            searchText: "",
            showDeletePopup: false,
            deleteItem: null,
            deleteToken: "",
            isLoading: false,
            listNVKinhDoanh: [],
            showUploadImgPopup: false,
            openRow: null,
            showThemNhomPopup: false,
            tenNhom: "",
            inputThemTenNhom: "",
            tenNhomXoa: "",
            themNhomToken: "",
            showSuaNhomPopup: false,
            idNhom: "",
            cuaHang: true,
            saoKeNhom: false,
            avatar: "",
            birthday: "",
            tenNguoiTao: "",
            tenNguoiSua: "",
            danhSachNguoi: [],
        };
    },
    async mounted() {
        this.getListCategory();

        this.user = localStorage.getItem(KEY_PHONE_ID);
        if (this.user == "" || this.user == null || this.user == undefined) {
            window.location.href = "/quantri/dangnhap";
        }

    },
    computed: {
        sortedNV() {
            return this.listNVKinhDoanh.slice().sort((a, b) => {
                const priority = {
                    1: 1,
                    2: 2,
                    0: 3
                }; // Ưu tiên theo thứ tự
                return priority[a.level] - priority[b.level];
            });
        }
    },
    methods: {
        xemSaoKe() {
            this.cuaHang = !this.cuaHang;
            this.saoKeNhom = !this.saoKeNhom;
        },

        toggleRow(index) {
            this.openRow = this.openRow === index ? null : index;
        },
        logoutTaiKhoan() {
            localStorage.removeItem(KEY_PHONE_ID);
            window.location.href = "/quantri/dangnhap";
        },
        clickBaiViet() {
            window.location.href = "/quantri/baiviet";
        },
        clickNhanSu() {
            window.location.href = "/quantri/nhansu";
        },
        clickDanhMuc() {
            window.location.href = "/quantri/trangchu";
        },

        confirmDelete(item) {
            this.deleteItem = item;
            this.tenNhomXoa = item.tenNhom;
            this.deleteToken = "";
            this.showDeletePopup = true;
        },
        async deleteBaiViet() {
            if (!this.deleteToken) {
                alert("Vui lòng nhập token xác nhận!");
                return;
            }
            this.isLoading = true;
            try {
                let idLogin = localStorage.getItem(KEY_PHONE_ID);
                let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
                let res = await postXoaNhomKD(this.deleteItem.id, this.deleteToken, idLogin, sessionLogin);

                if (res.msgCode === 1) {
                    alert("Đã xóa thành công!");
                    this.showDeletePopup = false;
                    this.getListCategory();
                    this.isLoading = false;
                } else {
                    alert("Xóa thất bại: " + res.msgContent);
                    this.isLoading = false;
                }
            } catch (e) {
                this.isLoading = false;
            }
        },
        moPopupSuaNhom(item) {
            this.idNhom = item.id;
            this.tenNhom = item.tenNhom; // lấy tên nhóm hiện tại
            this.showSuaNhomPopup = true;
        },
        async getListCategory() {
            let offset = "0";
            let limit = "100";
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let res = await postListNhomKD(limit, offset, idLogin, sessionLogin);
            this.listnhomkd = res.result.docs;
            if (this.listnhomkd.length > 0) {
                this.getDanhSachNguoiTrongNhom(this.listnhomkd[0]);
            }
        },

        async themNhomKD() {

            if (!this.tenNhom || !this.themNhomToken) {
                alert("Vui lòng nhập đủ thông tin!");
                return;
            }
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let res = await postTaoNhomKD(
                this.tenNhom,
                this.themNhomToken,
                idLogin,
                sessionLogin
            );
            if (res && res.msgCode === 1) {
                alert("Thêm nhóm thành công!");
                this.showThemNhomPopup = false;
                this.getListCategory();
            } else {
                alert("Thất bại: " + (res.data || "Lỗi không xác định"));
            }
        },

        async suaNhom() {
            if (!this.tenNhom || !this.themNhomToken) {
                alert("Vui lòng nhập đủ thông tin!");
                return;
            }
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let res = await postSuaNhomKD(
                this.idNhom,
                this.tenNhom,
                this.themNhomToken,
                idLogin,
                sessionLogin
            );
            if (res && res.msgCode === 1) {
                alert("Sửa nhóm thành công!");
                this.showSuaNhomPopup = false;
                this.getListCategory();
            } else {
                alert("Thất bại: " + (res.data || "Lỗi không xác định"));
            }
        },

        async getDanhSachNguoiTrongNhom(item) {
            this.diemThanhToan = 0;
            this.tenNhom = item.tenNhom;
            let offset = "0";
            let limit = "100";
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let res = await postListNVNhomKD(
                limit,
                offset,
                idLogin,
                sessionLogin,
                item.maNhom
            );
         
            this.listNVKinhDoanh = res.result.docs;
            for (let item of this.listNVKinhDoanh) {
                let soDiem = await this.getDanhSachCuaHangTrongNhom(item.id);
                item.soDiemDaTao = soDiem > 0 ? soDiem + " điểm" : ""; // Nếu 0 thì để rỗng
                this.diemThanhToan += soDiem;
                // console.log("diemThanhToan ", this.diemThanhToan);
            }
               this.getDanhSachCuaHangTrongNhom(item);
            this.getDanhSachGiaoDichCuaHangTrongNhom(item);
        },

        getTenNhanVien(viVimass) {
            const nv = this.listNVKinhDoanh.find(item => item.viVimass === viVimass);
            return nv ? nv.hoTen : viVimass; // Nếu không có thì giữ nguyên
        },

        async getDanhSachCuaHangTrongNhom(item) {

            let offset = "0";
            let limit = "100";
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let maNhom = item.maNhom || 0;
            let idTV = item.id || item;
            let res = await postListCuaHangNVTaoKD(
                limit,
                offset,
                idLogin,
                sessionLogin,
                maNhom,
                idTV
            );
            this.listCuaHangNVTao = res.result.docs || "Chưa có cửa hàng nào";
            // for (let item of this.listCuaHangNVTao) {
            //   item.tenNguoiTao = await this.searchName(item.accOwner);
            //   item.tenNguoiSua = await this.searchName(item.userEdit); // Lưu tên gọi
            // }
            // this.diemThanhToan = res.result.numFound || 0;
            return res.result.numFound || 0;
        },

        async getDanhSachGiaoDichCuaHangTrongNhom(item) {
            this.tenNhom = item.tenNhom;
            let offset = "0";
            let limit = "100";
            let idLogin = localStorage.getItem(KEY_PHONE_ID);
            let sessionLogin = localStorage.getItem(KEY_SESSION_ID);
            let maNhom = item.maNhom || "1";
            let idTV = item.id || item;
            let res = await postListGiaoDichCuaHangNVTaoKD(
                limit,
                offset,
                idLogin,
                sessionLogin,
                maNhom,
                idTV, "", "", 1761930001000, 1764521999000
            );
            this.listSaoKeGiaoDich = res.result.docs || "Chưa có giao dịch nào";
            this.tongTien = res.result.tongTien || 0;
            this.tongGiaoDich = res.result.numFound || 0;
            this.tongPhi = res.result.tongPhi || 0;
        },

        VMbase64Utf8(str) {
            if (!str || typeof str !== "string") return "";
            try {
                const binary = atob(str);
                const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
                return new TextDecoder().decode(bytes);
            } catch (e) {
                return "";
            }
        },
        formatTien(tien) {
            return new Intl.NumberFormat("vi-VN").format(tien);
        },
        formatDate(ms) {
            if (!ms || isNaN(ms)) return "-";
            const d = new Date(ms);
            return d.toLocaleString("vi-VN", {
                hour12: false
            });
        },

        async searchName(inputPalms) {
            try {
                const baseUrl = "http://210.245.8.6:8080/vmNoiBo/services/account/getAvt";
                const pass = "8249539tgsdlka";
                let palmId = inputPalms.trim();

                if (palmId.startsWith("3")) {
                    palmId = "V" + palmId;
                }

                const url = `${baseUrl}?param=${encodeURIComponent(palmId)}&pass=${encodeURIComponent(pass)}`;
                const response = await fetch(url);
                const payload = await response.text();

                if (!payload || payload.trim() === "") {
                    return "Chưa có tên gọi";
                }

                let token;
                try {
                    token = JSON.parse(payload);

                    return token.acc_name || token.acc_name || "Chưa có tên";
                } catch (e) {
                    return "Dữ liệu không hợp lệ";
                }
            } catch (err) {
                return "Lỗi khi lấy tên";
            }
        }
        // extraString(str){
        //   return atob(str);
        // }
    },
};
</script>

<style scoped>
.info-detail {
    background: #fff;
    border: 1px solid #e0e6ed;
    border-radius: 14px;
    padding: 22px;
    max-width: 450px;
    width: fit-content;
    margin-top: 18px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease-in-out;
    animation: fadeIn 0.35s ease-in-out;
    font-family: "Roboto", sans-serif;
}

.info-detail:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

/* Header */
.info-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

/* Title */
.info-detail h4 {
    font-size: 18px;
    color: #2c3e50;
    margin: 0;
    font-weight: 600;
}

/* Avatar */
.info-avatar {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    object-fit: cover;
    margin: 12px 0;
    border: 3px solid #2d7ffa;
    transition: transform 0.3s ease;
}

.info-avatar:hover {
    transform: scale(1.05);
}

/* Dòng thông tin */
.info-item {
    font-size: 15px;
    color: #34495e;
    padding: 6px 0;
    line-height: 1.5;
}

.info-item strong {
    color: #2d7ffa;
    min-width: 130px;
    display: inline-block;
    font-weight: 600;
}

.info-item i {
    margin-right: 6px;
}

/* Badge Chức vụ */
.badge-role {
    padding: 5px 12px;
    border-radius: 8px;
    font-size: 13px;
    color: white;
    font-weight: 600;
}

.badge-role.leader {
    background: #ff5252;
}

.badge-role.vice {
    background: #ff9800;
}

.badge-role.support {
    background: #4caf50;
}

/* Button */
.btn-email {
    display: inline-block;
    margin-top: 12px;
    padding: 8px 16px;
    background: #2d7ffa;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.25s ease-in-out;
}

.btn-email:hover {
    background: #1a5fd1;
}

.btn-email i {
    margin-right: 6px;
}

/* Animation */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(8px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive */
@media screen and (max-width: 768px) {
    .info-detail {
        max-width: 100%;
        padding: 16px;
    }

    .info-detail h4 {
        font-size: 16px;
    }

    .info-item {
        font-size: 14px;
    }
}

.header-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 12px 18px;
    border-radius: 10px;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 15px;
}

.header-group h5 {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    color: #344767;
    /* tone hiện đại */
}

.btn-add {
    background: linear-gradient(90deg, #007bff, #0056b3);
    border: none;
    color: #fff;
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
}

.btn-add:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 123, 255, 0.3);
}

.btn-add i {
    font-size: 14px;
}

/* Responsive mobile */
@media (max-width: 600px) {
    .header-group {
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }

    .btn-add {
        width: 100%;
        justify-content: center;
    }
}

.table> :not(:first-child) {
    border-top: 1px solid white;
}

.table thead th {
    border-bottom: none;
    background-color: rgba(9, 157, 190, 0.781);
    color: #ffffff;
    padding-top: 9px;
    /* padding-bottom: 15px; */
}

table,
td {
    border: 1px solid white;
    word-wrap: break-word;
}

.info-card {
    width: auto;
    padding: 14px 16px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    border-left: 5px solid transparent;
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
    transition: all .25s ease;
    cursor: pointer;
}

.info-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 7px 18px rgba(0, 0, 0, 0.12);
}

/* Tiêu đề cấp bậc */
.role {
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 12px;
    color: #fff;
    width: fit-content;
}

/* Màu theo cấp bậc */
.role.truong {
    background: #ff6b6b;
    border-left: 5px solid #d64545;
}

.role.pho {
    background: #ffa502;
    border-left: 5px solid #cc8500;
}

.role.tv {
    background: #2ed573;
    border-left: 5px solid #1eae59;
}

/* Text info */
.name {
    font-weight: 600;
    color: #344767;
}

.email {
    color: #6c757d;
    font-size: 13px;
}

/* Responsive align đẹp */
.row.gap-3 {
    gap: 15px;
}

@media (max-width: 500px) {
    .info-card {
        width: 100%;
    }
}

/* Bảng */
.table {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
}

.table thead.table-dark {
    background: linear-gradient(90deg, #1e293b, #334155) !important;
    color: #fff;
}

.table tbody tr {
    transition: all 0.15s ease-in-out;
}

.table tbody tr:hover {
    background: #f1f5f9 !important;
    cursor: pointer;
}

/* Hộp chi tiết */
.detail-card-modern {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    transition: 0.25s ease;
}

.detail-card-modern:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

/* Header trong chi tiết */
.detail-header {
    font-size: 16px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 14px;
}

.detail-header i {
    color: #2563eb;
    font-size: 18px;
}

/* Nội dung chi tiết bên trái */
.detail-info {
    font-size: 14px;
    padding: 5px 0;
}

.detail-info strong {
    color: #1e293b;
}

.detail-info a {
    color: #2563eb;
    text-decoration: none;
}

.detail-info a:hover {
    text-decoration: underline;
}

/* Map */
.detail-map {
    width: 100%;
    height: 300px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
}

/* Responsive chỉnh theo mobile */
@media (max-width: 768px) {
    .detail-map {
        height: 220px;
    }

    .detail-header {
        text-align: center;
        justify-content: center;
    }
}

.row>.col-md-6,
.row>.col-md-5 {
    padding-right: 15px;
    padding-left: 15px;
}

.row>.col-md-6.mb-2 strong,
.row>.col-md-5.mb-2 strong {
    color: #333;
}

.address-link {
    cursor: pointer;
    color: #007bff;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .row {
        flex-direction: column;
    }

    .col-md-6,
    .col-md-5 {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }

    .mt-3 {
        margin-top: 15px !important;
    }

    iframe {
        height: 250px;
    }
}

.info-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #333;
}

.card-cate {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    color: #176a94;
    margin-bottom: 15px;

    padding-bottom: 6px;
    text-align: start;
}

/* Header */
.header {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    margin-top: 0px;
}

.logout {
    color: #ff4d4f;
    font-weight: 600;
    text-decoration: none;
}

.logout:hover {
    text-decoration: underline;
}

/* Tabs */
.tabs {
    display: flex;
    gap: 8px;
    margin-bottom: 20px;
}

.tabs button {
    background: #f5f5f5;
    color: #444;
    border: 1px solid #ddd;
    padding: 10px 20px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 8px 8px 0 0;
    transition: all 0.2s;
    line-height: 1;
}

.tabs button:hover {
    background: #e6f7ff;
}

.tabs button.active {
    background: #176a94;
    color: #176a94;
    border-color: #176a94;
}

/* Main */
.main-content {
    display: flex;
    gap: 30px;
    align-items: flex-start;
}

.form-section {
    flex: 1;
    max-width: 500px;
}

.form-group {
    margin-bottom: 12px;
}

.form-group label {
    font-weight: 600;
    display: block;
    margin-bottom: 4px;
}

.form-group .sub {
    font-weight: normal;
    font-size: 12px;
    color: #888;
}

.form-group input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    transition: 0.2s;
}

.form-group input:focus {
    border-color: #176a94;
    outline: none;
    box-shadow: 0 0 4px rgba(23, 106, 148, 0.2);
}

.btn-primary {
    background: #176a94;
    color: #fff;
    border: none;
    padding: 10px 25px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
    transition: 0.2s;
}

.btn-primary:hover {
    background: #145b7e;
}

/* List */
.list-section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.list-section li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
    padding: 10px 0;
    font-size: 16px;
}

.category-link {
    color: #176a94;
    font-weight: 500;
    text-decoration: none;
    flex: 1;
}

.category-link:hover {
    text-decoration: underline;
}

/* Icons */
.icon {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-left: 6px;
    cursor: pointer;
}

.pagination {
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: flex-end;
}

.pagination button {
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid #176a94;
    background: #fff;
    color: #176a94;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    font-size: 15px;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination button:hover:not(:disabled) {
    background: #176a94;
    color: #fff;
}

.pagination span {
    font-weight: 600;
    color: #176a94;
    font-size: 15px;
}

.icon.edit {
    background: url('data:image/svg+xml;utf8,<svg fill="green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M7 17l5-5-2-2-5 5v2h2zm9.71-9.71a1.003 1.003 0 0 0-1.42 0l-1.34 1.34 2.12 2.12 1.34-1.34a1.003 1.003 0 0 0 0-1.42l-1.7-1.7z" fill="white"/></svg>') no-repeat center/contain;
}

.icon.delete {
    background: url('data:image/svg+xml;utf8,<svg fill="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M15.5 8.5l-7 7m0-7l7 7" stroke="white" stroke-width="2"/></svg>') no-repeat center/contain;
}

.list-section-cate ul {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    list-style: none;
    padding: 0;
    margin: 0;
}

.list-section-cate li {
    background: #f7fbfd;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(23, 106, 148, 0.06);
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: none;
    font-size: 16px;
}

.popup-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    animation: fadeIn 0.25s ease-in-out;
}

.popup-content {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    width: 420px;
    max-width: 90%;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    text-align: center;
    animation: scaleIn 0.25s ease-in-out;
}

.popup-content h5 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
}

.popup-content p {
    font-size: 14px;
    margin-bottom: 16px;
    color: #555;
}

.popup-content label {
    display: block;
    font-size: 14px;
    text-align: left;
    margin-bottom: 6px;
    color: #444;
}

.popup-content input {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #ccc;
    outline: none;
    transition: 0.2s;
    font-size: 14px;
}

.popup-content input:focus {
    border-color: #4a90e2;
    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.25);
}

.popup-actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}

.popup-actions button {
    padding: 8px 18px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.25s, transform 0.15s;
}

.cke_contents {
    height: 800px !important;
}

.popup-actions button:hover {
    transform: translateY(-1px);
}

.popup-actions button:first-child {
    background: #4a90e2;
    color: #fff;
}

.popup-actions button:first-child:hover {
    background: #3b7dc6;
}

.popup-actions button:last-child {
    background: #f0f0f0;
    color: #333;
}

.popup-actions button:last-child:hover {
    background: #e0e0e0;
}

/* Hiệu ứng */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes scaleIn {
    from {
        transform: scale(0.9);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.loading-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 2000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.loading-spinner {
    width: 48px;
    height: 48px;
    border: 6px solid #e0e0e0;
    border-top: 6px solid #176a94;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

.loading-text {
    color: #176a94;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 600px) {
    .list-section-cate ul {
        grid-template-columns: 1fr !important;
        gap: 10px;
    }

    .list-section-cate li {
        font-size: 15px;
        padding: 10px;
        flex-direction: column;
        align-items: flex-start;
    }

    .category-link {
        margin-bottom: 6px;
    }

    .list-section-cate input[type="number"] {
        width: 100%;
        margin-top: 4px;
    }
}
</style>
